import axios from 'axios/index';
import { CADESS_API_CONFIG, CADESS_API_SPECIMEN_STATUS, CADESS_API_CASE_STATUS, API_URL_PATHS } from '../constants/url';

export const uploadSpecimen = (formData) => {
  const url = `${process.env.REACT_APP_CADESS_API_URL}/specimen/upload`;
  const username = `${process.env.REACT_APP_CADESS_API_USERNAME}`;
  const password = `${process.env.REACT_APP_CADESS_API_PASSWORD}`;

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
    auth: {
      username,
      password,
    },
  };

  return axios.post(url, formData, config)
    .then((response) => response)
    .catch((error) => {
      console.log(error);
    });
};

export const getFullCaseStatus = async (cadessIds) => axios.get(`${CADESS_API_CASE_STATUS}/${cadessIds}`, CADESS_API_CONFIG)
  .then(response => response.data);

export const getFullCadessStatus = async (cadessId) => axios.get(`${CADESS_API_SPECIMEN_STATUS}/${cadessId}`, CADESS_API_CONFIG)
  .then(response => response.data);

export const getInstructions = async (role, userId) => (
  axios.get(`${API_URL_PATHS.instructionsUrl}/${role}/${userId}`, CADESS_API_CONFIG)
    .then(response => response.data)
    .catch(e => {
      console.log(e);
    }));

export const getCadessStatus = async (cadessId) => getFullCadessStatus(cadessId)
  .then((data) => {
    if (data.status) {
      return data.status;
    }
    return 'N/A';
  })
  .catch(() => 'N/A');
